<template>
<div>
    <common-header title="모바일 상품권 추가" :isModal="true" :showTitle="true" :showLeftMenu="false" :showBack="true" v-on:onBackPressed="onBackPressed"/>
    <main class="pay-egift order-select-main-mymenu">
        <div class="egift-list mymenulist">
            <div class="container">
              <h2 class="page-title">
                  <label for="chkAll">모바일 상품권</label>
              </h2>
              <div class="form-group mt40">
                <div class="form-box">
                  <input type="number" inputmode="numeric" pattern="[0-9]*" placeholder="상품권 번호를 입력하세요." v-model="giftNo">
                </div>
              </div>
              <div class="giftshop">
                <div class="btn-group02 mt30 ">
                  <button class="btn btn-full btn-primary" @click="fileOpen">모바일 상품권 이미지 불러오기</button>
                </div>
                <input hidden="hidden"  type="file" @change="handleFileChange" id="fileUpload" accept="image/*" />
              </div>
            </div>
            <div class="container">
                <h2 class="page-title">
                  <label for="chkAll">모바일 상품권 추가 안내</label>
                </h2>
                <ul class="ul-info02">
                    <li>상품권 번호 입력시 특수문자(공백, - 등)를 제외해 주세요.</li>
                    <li>최신 버전 앱에서만 모바일 상품권 이미지 불러오기를<br>사용할 수 있습니다.</li>
                    <li>상품권 이미지의 해상도가 낮은 경우 인식이 불가능할 수 있습니다.</li>
                </ul>
            </div>
            <button class="footer-bottom btn btn-full btn-primary" @click="applyEGift">추가하기</button>
        </div>
        <!-- 확인 팝업 -->
        <div class="pop-alert pop-confirm01">
            <div class="container">
                <div class="pop-header clearfix">
                    <div class="f-left">알림</div>
                    <div class="f-right">
                        <button type="button" class="pop-close" onclick="closePopAlert();"><span class="blind">팝업닫기</span></button>
                    </div>
                </div>
                <div class="pop-content">
                    <p>
                        멤버십 e-Gift와 동일한 가격 이상<br>구매 시 쿠폰 적용이 가능합니다
                    </p>
                    <button type="button" class="pop-close" @click="applyEGift();">적용</button>
                    <button type="button" class="pop-close btn-sm-border" @click="closePopAlert();">취소</button>
                </div>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import { OrderConfig } from '@/store/Constraints';
import Quagga from 'quagga';
import {isEqual} from "lodash";
export default {
    data() {
        return {
            giftNo:''
        }
    },
    mounted() {

    },

    computed: {
        externalGiftsResult() {
          return this.$store.getters[OrderConfig.EXTERNAL_GIFTS_RESULT];
        }
    },
    watch: {
    },
    methods: {
        onBackPressed: function () {
            this.close();
        },
        close() {
            this.$emit('onBackPressed');
            this.$modal.hide('SelectMobileGiftAddDialog');
            this.$modal.hideAll();
        },
        applyEGift () {
            this.$store.dispatch(OrderConfig.EXTERNAL_GIFTS,{externalGiftNo:this.giftNo})
              .then(res => {
                this.showLoading(false)
                if (res.code == "0000") {
                  const exists = this.externalGiftsResult.some(obj => isEqual(obj, res.data));
                  if (!exists) {
                    this.externalGiftsResult.push(res.data);
                    this.onBackPressed();
                  }else {
                    this.showAlert("이미 추가 된 모바일 상품권 입니다.");
                  }
                }else{
                  this.showAlert(res.message);
                }
              })
              .catch(err => {
                console.log(err);
              })
          this.showLoading(true)
        },
        getImage: function (image) {
            console.log(image)
            return image && image.indexOf("http") >= 0 ? image : require('@/assets/img/img-menu01.png');
        },
        decodeBarcode : function (imageUrl) {
            Quagga.decodeSingle({
              src: imageUrl,
              numOfWorkers: 0, // Using zero workers to run the decoder on the main thread
              decoder: {
                readers: [
                  'code_128_reader'
                ]
              }
            }, (result) => {
              try {
                if (result.codeResult) {
                  this.giftNo = result.codeResult.code;
                } else {
                  this.showAlert('바코드를 인식할 수 없습니다.\n수기로 입력해주세요.')
                }
              }catch (e){
                this.showAlert('바코드를 인식할 수 없습니다.\n수기로 입력해주세요.');
              }
            });
        },
          handleFileChange : function (event) {
            const file = event.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onload = () => {
                const imageUrl = reader.result;
                this.decodeBarcode(imageUrl);
              };
              reader.readAsDataURL(file);
            }
        },
        fileOpen : function (){
          document.getElementById("fileUpload").click()
        }

    }
}
</script>




// WEBPACK FOOTER //
// src/components/order/SelectMobileGiftAddDialog.vue